module.exports = __webpack_public_path__ + "assets/img/shelp2.58e6c779.png";